<template>
  <div class="bg-white h-full w-full">
    <GradientHeader
      :logo="logo"
      :colour="colours.primary"
      fullHeight
    >
      <OffsetColorBox
        :colour="colours.accentPrimary"
        :gray="colours.primaryIsWhite"
        class="w-160 max-w-full mx-auto px-4"
        smallHeading
        boxInnerClass="md:px-10"
      >
        <template slot="heading">
          {{ $t('passwordProtect.passwordRequired') }}
        </template>

        <IconCircular
          slot="icon"
          class="bg-warn !w-10 !h-10 translate-y-1"
          :style="`background: ${colours.accentPrimary}`"
        >
          <LockIcon
            class="w-3/5"
            :style="`color: ${colours.accentSecondary}`"
          />
        </IconCircular>

        <p class="text-body px-4 md:px-8">{{ $t('passwordProtect.passwordRequiredMessage') }}</p>

        <PasswordEntry
          :passwordStatus="passwordStatus"
          :getEnvelope="getEnvelope"
          class="px-4 md:px-8"
        />
      </OffsetColorBox>
    </GradientHeader>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'

import GradientHeader from '@/components/library/GradientHeader.vue'
import OffsetColorBox from '@/components/library/OffsetColorBox.vue'
import IconCircular from '@/components/icons/IconCircular.vue'
import LockIcon from '@/components/icons/LockIcon.vue'
import PasswordEntry from '@/components/library/PasswordEntry.vue'

const props = defineProps({
  branding: Object,
  passwordStatus: Object,
  getEnvelope: Function
})

const colours = computed(() => props.branding ? props.branding.colours : { accentSecondary: '#ffffff' })
const logo = computed(() => props.branding && props.branding.logo)
</script>
